import { BcLowaCheckResult, BlueConicReadyOptions } from './_models';
import { BlueConicLowaService, BlueConicReadinessService } from './services';

export interface MNGAuthBlueconicApi {
  blueConicReady: (options?: BlueConicReadyOptions) => Promise<boolean>;
  bcLowaCheck: (setBCLowaCookie?: boolean) => Promise<BcLowaCheckResult>;
  bcGetAuth0Id: () => Promise<string | false>;
}

export const Blueconic: MNGAuthBlueconicApi = {
  blueConicReady: (options) =>
    BlueConicReadinessService.Instance.blueConicReady(options),
  bcLowaCheck: (setBCLowaCookie = false) =>
    BlueConicLowaService.Instance.bcLowaCheck(setBCLowaCookie),
  bcGetAuth0Id: () => BlueConicLowaService.Instance.bcGetAuth0Id(),
};
